import "esbuild-css-modules-plugin-ns-css:src/lib/gantt-task-react/src/components/other/vertical-scroll.module.css";

export default {
  "scroll": "vertical-scroll-module__scroll_doWV5W__100"
};
      